import { SxProps } from "@mui/material";

export const datePickerContainerStyle: SxProps = {
  position: "absolute",
  background: "white",
  zIndex: "1",
  borderRadius: "8px",
  border: "1px solid #333 !important",
  mt: "50px",
  boxShadow: "4px 4px 17px 0px #38416429",
};
